export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10576.5bc40424.jpg";